import { COLORS } from '../../styles/design-tokens';

const TABS = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={active ? COLORS.amber : COLORS.textDim}
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
      </svg>
    ),
  },
  {
    id: "map",
    label: "Map",
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={active ? COLORS.amber : COLORS.textDim}
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
  },
  {
    id: "tracked",
    label: "Tracked",
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={active ? COLORS.amber : COLORS.textDim}
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    ),
  },
];

export default function BottomNav({ tab, setTab, onTabChange, notificationCounts = {} }) {
  const handleTab = (id) => {
    setTab(id);
    if (onTabChange) onTabChange(id);
  };

  return (
    <div style={{
      position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)",
      width: "100%", maxWidth: 430,
      background: COLORS.navBg,
      borderTop: `1px solid ${COLORS.cardBorder}`,
      display: "flex", justifyContent: "space-around", alignItems: "center",
      padding: "8px 0 20px", zIndex: 100,
    }}>
      {TABS.map(t => {
        const active = tab === t.id;
        const count = Math.max(0, Number(notificationCounts[t.id] || 0));
        const label = count > 0 ? `${t.label}, ${count} notification${count === 1 ? '' : 's'}` : t.label;
        return (
          <button
            key={t.id}
            aria-label={label}
            onClick={() => handleTab(t.id)}
            style={{
              background: "none", border: "none",
              color: active ? COLORS.amber : COLORS.textDim,
              display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
              cursor: "pointer", fontFamily: "'DM Sans', sans-serif", padding: "4px 20px",
              position: "relative",
            }}
          >
            <span style={{ position: "relative", display: "inline-flex" }}>
              {t.icon(active)}
              {count > 0 && (
                <span
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    top: -7,
                    right: -9,
                    minWidth: 16,
                    height: 16,
                    padding: "0 4px",
                    borderRadius: 999,
                    background: "#d84040",
                    color: "#fff",
                    border: `1.5px solid ${COLORS.navBg}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 9,
                    lineHeight: 1,
                    fontWeight: 800,
                    boxSizing: "border-box",
                  }}
                >
                  {count > 9 ? "9+" : count}
                </span>
              )}
            </span>
            <span style={{ fontSize: 11, fontWeight: active ? 700 : 500 }}>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
